import React, { useEffect, useState } from "react";
import "../css/Reportes.css"

import { useAuth } from "../hooks/AuthProvider.js";
import miAxios from "../api/axios.js";
import { Snackbar, Alert, IconButton, InputAdornment, FormControlLabel, Switch, Grid2, TextField, Autocomplete, FormControl, InputLabel, Select, MenuItem, Button } from "@mui/material";
import SyncIcon from '@mui/icons-material/Sync';
import Wait from "../components/Wait";
import SearchIcon from '@mui/icons-material/Search';
import { useParams, useSearchParams } from "react-router-dom";
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
const getHoy = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-' + mm + '-' + dd;
    return today;
}
const getInicioMes = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-' + mm + '-01';
    return today;
}

const valoresDefecto = [
    {
        nombre: "desde",
        valor: getInicioMes()
    },
    {
        nombre: "hasta",
        valor: getHoy()
    },
    {
        nombre: "proveedor",
        valor: 0,
        presenta: null
    },
    {
        nombre: "estatus",
        valor: 0
    },
    {
        nombre: "incluye_nulas",
        valor: 0,
        presenta: false
    },
    {
        nombre: "cliente",
        valor: 0,
        presenta: "",
        presenta2: ""
    },
    {
        nombre: "estatusr",
        valor: 0
    },
    {
        nombre: "compania",
        valor: 0
    },
    {
        nombre: "celular",
        valor: ""
    },
    {
        nombre: "estatus_proceso_recarga",
        valor: 1
    },
    {
        nombre: "institucion",
        valor: -1
    }
]

export default function Reportes() {
    const [parametros, setParametros] = useState([])
    const [procesando, setProcesando] = useState(false)
    const [procesandoReporte, setProcesandoReporte] = useState(false)
    const [filtros, setFiltros] = useState([])
    const [rowsProveedores, setRowsProveedores] = useState([])
    const [rowsCompanias, setRowsCompanias] = useState([])
    const [rowsInstituciones, setRowsInstituciones] = useState([])
    const [rowsEstatus, setRowsEstatus] = useState([])
    const [mensaje, setMensaje] = useState({ texto: "", tipo: "error" })
    const [src, setSrc] = useState(null)
    const [openBuscaCl, setOpenBuscaCl] = useState(false)
    const [esconder, setEsconder] = useState(false)

    const user = useAuth()
    const axios = miAxios(user.handleLogout)
    const [searchParams] = useSearchParams();

    const { reporte } = useParams()


    useEffect(() => {
        actParametros()
        //actRowsProveedores()
        //actRowsEstatus()
        //actRowsCompaniasRecargas()
        //actRowsInstituciones()
    }, [])

    const handleBuscarCl = (index) => {
        if (filtros[index].presenta?.length > 0) {
            actInfoCl(index)
        }
    }

    const handleCloseMensaje = () => {
        setMensaje({ texto: "", tipo: "error" })
    }

    const actInfoCl = async (index) => {
        let nr = filtros.map((row, ind) => {
            if (ind == index) {
                return {
                    ...row,
                    valor: 0,
                    presenta: "",
                    presenta2: ""
                }
            } else {
                return row
            }
        })
        setFiltros(nr)

        setProcesando(true)
        try {
            const response = await axios.post("/clientes/info2", {
                cliente: 0,
                cedula: filtros[index].presenta
            })
            const data = response.data;
            if (data.respuesta == "S") {
                if (parseInt(data.id) == 0) {
                    setMensaje({ texto: "Cliente no encontrado", tipo: "error" })
                } else {
                    let nr = filtros.map((row, ind) => {
                        if (ind == index) {
                            return {
                                ...row,
                                valor: data.id,
                                presenta: data.cedula,
                                presenta2: data.nombre + " " + data.apellido
                            }
                        } else {
                            return row
                        }
                    })
                    console.log(nr)
                    setFiltros(nr)
                }

            } else {
                setMensaje({ texto: data.mensaje, tipo: "error" })
            }
        } catch (error) {
            console.log("el error fue", error)
            //setMensaje({texto: error.m, tipo: "error"})
        }

        setProcesando(false)
    }


    const objClientes = (index) => {
        return <div className="Rep-clientes">
            <div>
                <TextField
                    color="coopinfa"
                    value={filtros[index].presenta}
                    onChange={(event) => {
                        const nr = filtros.map((filtro, ind) => {
                            if (ind == index) {
                                return {
                                    ...filtro,
                                    valor: 0,
                                    presenta: event.target.value,
                                    presenta2: ""
                                }
                            } else {
                                return filtro
                            }
                        });
                        console.log(nr)
                        setFiltros(nr)
                    }}
                    type="text"
                    label="Cédula"
                    fullWidth
                    slotProps={{
                        inputLabel: { shrink: true },
                        input: {
                            endAdornment: <InputAdornment position="end">
                                <IconButton onClick={() => { handleBuscarCl(index) }}>
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                    }}
                />
            </div>
            <div>
                <TextField
                    value={filtros[index].presenta2}
                    type="text"
                    label="Nombre"
                    fullWidth
                    disabled
                    slotProps={{
                        inputLabel: { shrink: true },
                    }}
                />
            </div>
        </div>
    }

    const actParametros = async () => {
        setProcesando(true)

        try {
            const response = await axios.get("reportes/parametros?reportPath=" + reporte)
            const data = response.data;
            if (response.data.length == 0) {
                handleGenerar()
            } else {
                let recibeId = false;
                if (response.data.length == 1) {
                    if (response.data[0] == "id") {
                        recibeId = true;
                    }
                }
                if (recibeId) {
                    const id = searchParams.get('id');
                    handleGenerar(id)
                } else {
                    setParametros(data)
                    let f = []
                    data.forEach((row) => {
                        let valor = null;
                        valoresDefecto.filter((s) => s.nombre == row).forEach((s) => { valor = s.valor })
                        f.push({
                            nombre: row,
                            valor: valor,
                            inicial: valor
                        })
                    })
                    setFiltros(f)
                }

            }

        } catch (error) {
            console.log(error)
        }

        setProcesando(false)
    }

    const actValor = (index, valor) => {
        //si el valor es nulo, lo vuelvo a su por defecto..
        if (valor == null) {
            valor = filtros[index].inicial
        }


        let valorReal = valor;
        if (typeof valor === "object") {
            valorReal = valor?.id
        }
        if (typeof valor === "boolean") {
            valorReal = (valor ? -1 : 0)
        }
        const nr = filtros.map((row, ind) => {
            if (ind == index) {
                return {
                    ...row,
                    valor: valorReal,
                    presenta: valor
                }
            } else {
                return row
            }
        })

        setFiltros(nr)
    }

    const actRowsProveedores = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("/listas/proveedores2")
            const data = response.data;
            if (data.respuesta == "S") {
                const nr = data.datos.map((row) => {
                    return {
                        id: row.id,
                        label: row.texto
                    }
                })
                setRowsProveedores(nr)
            } else {
                setMensaje({ texto: data.mensaje, tipo: "error" })
            }
        } catch (error) {
            console.log("el error fue", error)
            //setMensaje({texto: error.m, tipo: "error"})
        }

        setProcesando(false)
    }

    const actRowsCompaniasRecargas = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("/listas/recargas_companias")
            const data = response.data;
            if (data.respuesta == "S") {
                const nr = data.datos.map((row) => {
                    return {
                        id: row.id,
                        label: row.texto
                    }
                })
                setRowsCompanias(nr)
            } else {
                setMensaje({ texto: data.mensaje, tipo: "error" })
            }
        } catch (error) {
            console.log("el error fue", error)
            //setMensaje({texto: error.m, tipo: "error"})
        }

        setProcesando(false)
    }

    const actRowsInstituciones = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("/listas/instituciones")
            const data = response.data;
            if (data.respuesta == "S") {
                const nr = data.datos.map((row) => {
                    return {
                        id: row.id,
                        label: row.texto
                    }
                })
                setRowsInstituciones(nr)
            } else {
                setMensaje({ texto: data.mensaje, tipo: "error" })
            }
        } catch (error) {
            console.log("el error fue", error)
            //setMensaje({texto: error.m, tipo: "error"})
        }

        setProcesando(false)
    }

    const actRowsEstatus = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("/listas/orden_estatus")
            const data = response.data;
            if (data.respuesta == "S") {
                const nr = data.datos.map((row) => {
                    return {
                        id: row.id,
                        nombre: row.texto
                    }
                })
                setRowsEstatus(nr)
            } else {
                setMensaje({ texto: data.mensaje, tipo: "error" })
            }
        } catch (error) {
            console.log("el error fue", error)
            //setMensaje({texto: error.m, tipo: "error"})
        }

        setProcesando(false)
    }

    const objFiltros = (nombre, index) => {
        if (nombre == "desde") {
            return <TextField
                key={index}
                value={filtros[index].valor}
                onChange={(event) => { actValor(index, event.target.value) }}
                color="coopinfa"
                fullWidth
                type="date"
                label="Desde"
                slotProps={{ inputLabel: { shrink: true } }}
            />
        } else if (nombre == "hasta") {
            return <TextField
                key={index}
                value={filtros[index].valor}
                onChange={(event) => { actValor(index, event.target.value) }}
                color="coopinfa"
                fullWidth
                type="date"
                label="Hasta"
                slotProps={{ inputLabel: { shrink: true } }}
            />
        } else if (nombre == "estatus") {
            return <FormControl color="coopinfa" fullWidth>
                <InputLabel id="estatus-label">Estatus</InputLabel>
                <Select
                    labelId="estatus-label"
                    size="large"
                    value={filtros[index].valor}
                    label="Estatus"
                    onChange={(event) => { actValor(index, event.target.value) }}
                >
                    <MenuItem key={0} value={0}>{"(Seleccione)"}</MenuItem>
                    {
                        rowsEstatus.map((row) => {
                            return (
                                <MenuItem key={row.id} value={row.id}>
                                    {row.nombre}
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </FormControl>
        } else if (nombre == "incluye_nulas") {
            return <FormControlLabel control={<Switch checked={filtros[index].presenta} color="coopinfa" onChange={(event) => { actValor(index, event.target.checked) }} />} label="Incluir Nulas" />
        } else if (nombre == "cliente") {
            return objClientes(index)
        } else if (nombre == "estatusr") {
            return <FormControl color="coopinfa" fullWidth>
                <InputLabel id="estatusr-label">Estatus</InputLabel>
                <Select
                    labelId="estatusr-label"
                    size="large"

                    value={filtros[index].valor}
                    label="Estatus"
                    onChange={(event) => { actValor(index, event.target.value) }}
                >
                    <MenuItem key={0} value={0}>{"(Seleccione)"}</MenuItem>
                    <MenuItem value={1}>{"Pendientes"}</MenuItem>
                    <MenuItem value={2}>{"Realizadas"}</MenuItem>
                    <MenuItem value={-1}>{"Rechazadas"}</MenuItem>
                </Select>
            </FormControl>
        } else if (nombre == "celular") {
            return <TextField
                value={filtros[index].valor}
                fullWidth
                color="coopinfa"
                onChange={(event) => { actValor(index, event.target.value) }}
                type="text"
                label="Celular"
                slotProps={{
                    inputLabel: { shrink: true },
                }}
            />
        } else if (nombre == "compania") {
            return <FormControl color="coopinfa" fullWidth>
                <InputLabel id="comp-label">Telefónica</InputLabel>
                <Select
                    labelId="comp-label"
                    size="large"
                    value={filtros[index].valor}
                    label="Telefónica"
                    onChange={(event) => { actValor(index, event.target.value) }}
                >
                    <MenuItem key={0} value={0}>{"(Seleccione)"}</MenuItem>
                    {
                        rowsCompanias.map((row) => {
                            return (
                                <MenuItem key={row.id} value={row.id}>
                                    {row.label}
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </FormControl>
        } else if (nombre == "estatus_proceso_recarga") {
            return <FormControl color="coopinfa" fullWidth>
                <InputLabel id="estatusrr-label">Estatus</InputLabel>
                <Select
                    labelId="estatusrr-label"
                    size="large"

                    value={filtros[index].valor}
                    label="Estatus"
                    onChange={(event) => { actValor(index, event.target.value) }}
                >
                    <MenuItem value={1}>{"Pendientes"}</MenuItem>
                    <MenuItem value={2}>{"Préstamos generados"}</MenuItem>
                </Select>
            </FormControl>
        } else if (nombre == "institucion") {
            return <FormControl color="coopinfa" fullWidth>
                <InputLabel id="ins-label">Institución</InputLabel>
                <Select
                    labelId="ins-label"
                    size="large"
                    value={filtros[index].valor}
                    label="Institución"
                    onChange={(event) => { actValor(index, event.target.value) }}
                    slotProps={{
                        inputLabel: { shrink: true },
                    }}
                >
                    <MenuItem key={0} value={-1}>{"(Todas)"}</MenuItem>
                    {
                        rowsInstituciones.map((row) => {
                            return (
                                <MenuItem key={row.id} value={row.id}>
                                    {row.label}
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </FormControl>
        }
    }

    const getParametros = () => {
        let str = ""
        filtros.filter((r) => r.nombre != "proveedor").forEach((filtro) => {
            /*let mvalor = filtro.valor
            if (typeof mvalor === "string" ){
                if (mvalor.length==0){return;}
            }*/
            str = str + (str.length > 0 ? "&" : "") + filtro.nombre + "=" + filtro.valor
        })
        return str
    }

    const handleGenerar = async (id) => {
        let parametros = "";
        if (typeof id === 'undefined') {
            parametros = "proveedor=" + localStorage.getItem("proveedor") + "&" + getParametros()
        } else {
            parametros = "id=" + id
        }

        console.log("Parametros...", parametros)

        setProcesandoReporte(true)
        try {
            const response = await axios.post("/reportes/imprimir", {
                reporte: reporte,
                parametros: parametros
            }, {
                responseType: "blob"
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            //window.open(url, "_blank")
            setEsconder(true)
            setSrc(url)

            //setTimeout(() => window.URL.revokeObjectURL(url), 60000);

        } catch (error) {
            console.log("el error fue", error)
            //setMensaje({texto: error.m, tipo: "error"})
        }

        setProcesandoReporte(false)

    }

    return (
        <div className="Rep-cuerpo">
            <Wait procesando={procesando} />
            <Wait procesando={procesandoReporte} />
            <Snackbar
                open={mensaje.texto.length == 0 ? false : true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseMensaje}
            >
                <Alert severity={mensaje.tipo} onClose={handleCloseMensaje} variant="filled">{mensaje.texto}</Alert>
            </Snackbar>
            {(parametros.length > 0 ? <>
                <div className={"Rep-filtro " + (esconder ? "escondido" : "")}>

                    <div className="Rep-filtrob">
                        <div className="Rep-filtro-bt"><IconButton onClick={() => { setEsconder(!esconder) }} size="small">{(esconder ? <KeyboardDoubleArrowDownIcon fontSize="small" /> : <KeyboardDoubleArrowUpIcon fontSize="small" />)}</IconButton></div>

                        {(!esconder ? <><Grid2 container spacing={2}>
                            {
                                parametros.map((row, index) => {
                                    return <Grid2 key={index} size={{ xs: 12, md: 4 }}  >
                                        {objFiltros(row, index)}
                                    </Grid2>
                                })
                            }
                        </Grid2>
                            <div className="Rep-filtro-act">
                                <Button variant="contained" color="coopinfa" onClick={()=>{handleGenerar()}}><SyncIcon /></Button>
                            </div></> : null)}
                    </div>

                </div></> : null)
            }
            <div className="Rep-viewer">
                <iframe src={src} width={"100%"} height={"100%"} >

                </iframe>
            </div>
        </div >
    )
}